// extracted by mini-css-extract-plugin
export default {"wrap":"yp-z","fullWidth":"zp-z","items":"Ap-z","featureCss":"Bp-z","disabled":"Cp-z","imgCss":"Dp-z"};